import React, { useRef, useState } from 'react';
import { brandColors } from '../styles/clientManagementStyles';

// Feedback only: the caller keeps its existing blur validation and persistence.
export default function SaveOnBlurInput({ onBlur, inputKey, ...props }) {
  const [status, setStatus] = useState('');
  const revision = useRef(0);
  return (
    <div style={{ minWidth: 0 }}>
      <input {...props} key={inputKey} onChange={() => {
        revision.current += 1;
        setStatus('');
      }} onBlur={async event => {
        if (String(event.target.value) === String(props.defaultValue ?? '')) return;
        const attempt = ++revision.current;
        setStatus('Saving…');
        try {
          const result = await onBlur(event);
          if (revision.current === attempt) setStatus(result === true ? 'Saved' : "Couldn't save");
        } catch {
          if (revision.current === attempt) setStatus("Couldn't save");
        }
      }} />
      <span role="status" style={{ display: 'block', fontSize: 11, marginTop: 4, color: status === "Couldn't save" ? brandColors.red : brandColors.silver }}>{status}</span>
    </div>
  );
}
